import { cacheDom } from "../utils/QuerySelectors.js"
import { videoHtml, videoControl } from "../utils/helpers.js"

const dom = {}
const qs = {
  json: 'data-video-json',
  placeholder: 'data-video-placeholder',
}
const qsAll = {
  sections: 'data-section-type="three-up"',
  videoWrappers: 'data-threeup-video',
}

const iObserver = new IntersectionObserver(items => {
  if (items[0].isIntersecting) {
    const section = items[0].target
    if(!section.classList.contains('three-up--videos__inited')) initSection(section)
  }
})

const initSection = (section) => {
  section.classList.add('three-up--videos__inited')
  const videoWrappers = section.querySelectorAll(`[${qsAll.videoWrappers}]`)
  videoWrappers.forEach(videoWrapper => {
    let video = videoWrapper.querySelector('video')
    const json = JSON.parse(videoWrapper.querySelector(`[${qs.json}]`).innerHTML)
    if(!video) {
      videoWrapper.innerHTML = videoHtml(json.video.sources, json.sectionId, 'absolute top-1/2 left-1/2 w-full h-full -translate-x-1/2 -translate-y-1/2 object-cover', json.controls, json.video.preview_image.src) + videoWrapper.innerHTML
      video = videoWrapper.querySelector(`[${qs.video}]`)
      videoControl(video)
      if(videoWrapper.querySelector(`[${qs.placeholder}]`)) {
        setTimeout(() => {
          videoWrapper.querySelector(`[${qs.placeholder}]`).remove()
        }, 300)
      }
    }
  })
}

export const setupThreeUps = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    if(section.classList.contains('three-up--videos')) iObserver.observe(section)
  })
}